import { useWebSocketManager } from "../../../hooks/useWebSocketManager";

export const WebSocketConnectHelper = ({ children }) => {
  useWebSocketManager();

  return children;
};
